import React, { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import styles from './index.module.scss';
import Button from '@material-ui/core/Button';
import { useStore, StoreTypes } from 'context';
import * as types from 'constants/actionTypes';
import { useInteractiveObjectContentCommandFactory } from 'customHooks/InteractiveObjectContentCommands/commandFactory';

const Submenu = ({ submenuInfo }) => {
    const [, readerDispatch] = useStore(StoreTypes.reader);
    const { list, position, target } = submenuInfo;
    const submenuContent = useRef(null);
    const CommandFactory = useInteractiveObjectContentCommandFactory();

    const itemClickHandler = (e, item) => {
        const command = CommandFactory.createCommand(item);
        command && command.execute({ json: item });
    }

    const closeSubmenu = () => {
        readerDispatch({ type: types.SET_SUBMENU_INFO, submenuInfo: null })
    }

    useEffect(() => {
        const submenuContentDom = ReactDOM.findDOMNode(submenuContent.current)
        if(!target)return;
        const { x, y, width, height } = target.getBoundingClientRect()
        if (submenuContentDom) {
            switch (position) {
                case "top":
                    submenuContentDom.style.top = (y - (submenuContent.current.clientHeight) - 5) + "px";
                    submenuContentDom.style.left = (x) + "px";
                    break;
                case "right":
                    submenuContentDom.style.top = (y) + "px";
                    submenuContentDom.style.left = (x + width + 10) + "px";
                    break;
                case "bottom":
                    submenuContentDom.style.top = (y + height + 5) + "px";
                    submenuContentDom.style.left = (x) + "px";
                    break;
                case "left":
                    submenuContentDom.style.top = (y) + "px";
                    submenuContentDom.style.left = (x - submenuContent.current.clientWidth - 10) + "px";
                    break;
                default:
                    submenuContentDom.style.top = (y + height + 5) + "px";
                    submenuContentDom.style.left = (x) + "px";
                    break;
            }
        }
    })

    return <div className={styles.submenuContent} onClick={closeSubmenu}>
        <div className={styles.items} ref={submenuContent}>
            <ul className={styles.itemul}>
                {
                    list.map((item, index) => {
                        return <li className={styles.itemli} key={index}>
                            {
                                <Button
                                    className="submenuLists"
                                    style={{
                                        textTransform: "none",
                                        color: "#fff",
                                        minWidth: "max-content",
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        height: "30px"
                                    }} onClick={(e) => { itemClickHandler(e, item) }}>{item.name}</Button>
                            }
                        </li>
                    })
                }
            </ul>
        </div>
    </div>
};

export default Submenu;